import React from 'react'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { Box, Flex, Text } from '@fundamentals'
import EastIcon from '@mui/icons-material/East'
import { TimelineBlockBase } from '@common/Timeline'
import { PageUrls } from '@core/page-urls'

type ComponentProps = {
  user: AuditResult['user']
  transferReceiver: AuditResult['metadata']['transferReceiver']
  title: string
  projectId: number
  organisationId: number
}

export const TimelineTransferBlock: React.FC<ComponentProps> = ({
  user,
  transferReceiver,
  title,
  projectId,
  organisationId,
}) => {
  return (
    <TimelineBlockBase title={title}>
      <Flex alignItems='center' justifyContent='flex-start'>
        <Box>
          <Link
            href={PageUrls.organisationUserProfile({
              organisationId,
              userId: user.id,
              query: { projectId },
            })}
            target='_blank'
          >
            <Text>{user.getFullName()}</Text>
          </Link>
          <Text fontSize={12}>{user.company}</Text>
        </Box>
        <EastIcon sx={{ mx: 2, opacity: 0.5 }} />
        <Box>
          <Link
            href={PageUrls.organisationUserProfile({
              organisationId,
              userId: transferReceiver.id,
              query: { projectId },
            })}
            target='_blank'
          >
            <Text>{transferReceiver.getFullName()}</Text>
          </Link>
          <Text fontSize={12}>{transferReceiver.company}</Text>
        </Box>
      </Flex>
    </TimelineBlockBase>
  )
}
